import * as React from "react";
import {
  FArticleInterface,
  FArtstockInterface,
} from "../../../interfaces/FArticleInterface";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import Typography from "@mui/material/Typography";
import { DEFAULT_DEPOT } from "../../../utils/FArticleUtils";
import UpdateEmplacementComponent from "../entreeStock/UpdateEmplacementComponent";
import Box from "@mui/material/Box";

interface State {
  fArticle: FArticleInterface | undefined;
}

const FArticleEmplacementComponent: React.FC<State> = React.memo(
  ({ fArticle }) => {
    const { t } = useTranslation();
    const isAdmin = useAppSelector(
      (state: RootState) => state.globalState.isAdmin
    );
    const getFArtStock = React.useCallback(():
      | FArtstockInterface
      | undefined => {
      if (fArticle && fArticle.fArtstocks && fArticle.fArtstocks.length > 0) {
        return fArticle.fArtstocks.find((x) => x.fDepot.deNo === DEFAULT_DEPOT);
      }
      return undefined;
    }, [fArticle]);
    const [fArtStock, setFArtStock] = React.useState<
      FArtstockInterface | undefined
    >(getFArtStock());
    const getEmplacement = React.useCallback((): string => {
      return fArtStock?.cbdpNoprincipal?.dpCode ?? "";
    }, [fArtStock?.cbdpNoprincipal?.dpCode]);
    const [emplacement, setEmplacement] = React.useState<string>(
      getEmplacement()
    );

    React.useEffect(() => {
      setFArtStock(getFArtStock());
    }, [fArticle]); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
      setEmplacement(getEmplacement());
    }, [fArtStock?.cbdpNoprincipal?.dpCode]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        {fArticle && isAdmin && fArtStock && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography>{t("word.emplacement") + ": "}</Typography>
            <UpdateEmplacementComponent
              emplacement={emplacement}
              arRef={fArticle!.arRef}
              fArtstockCbmarq={
                fArticle.fArtstocks?.find(
                  (f) => f.fDepot.deNo === DEFAULT_DEPOT
                )?.cbmarq
              }
              setEmplacement={setEmplacement}
            />
          </Box>
        )}
      </>
    );
  }
);

export default FArticleEmplacementComponent;
